export const meta: BlockMeta = {
  title: "Donate",
  tags: ["subpage"],
  flags: {
    fullWidth: true,
  },
}

import { TextImageThemeTile } from "@components/atoms/TextImageThemeTile"
import { Button } from "@components/ui/Button"
import { useSquadup } from "@features/ticketing/useSquadUp"
import { defineBlock, EditableText } from "eddev/blocks"

export default defineBlock("content/donate", (props) => {
  const squadup = useSquadup()

  return (
    <TextImageThemeTile theme={props.themeall || "yellow"} image={props.image || undefined}>
      <div className="w-full flex flex-col gap-7">
        <div className="w-full flex flex-col gap-4">
          <EditableText
            className="type-title-s pr-8"
            as="h2"
            store="title"
            defaultValue="Make a donation"
            placeholder="Make a donation"
            plainText
          />
          <EditableText
            store="subtitle"
            as="p"
            className="type-body-s"
            defaultValue="Every dollar you donate will be matched by Miami Film Society!"
            placeholder="Every dollar you donate will be matched by Miami Film Society!"
          />
        </div>
        <div className="w-full flex flex-col gap-2 [&_button]:my-0 [&_button]:!w-full [&_button]:!justify-start">
          <Button
            onClick={() => {
              squadup.openEvent(props.miscSettings?.donationOptions?.squadupDonationsId!)
            }}
          >
            <EditableText store="buttonLabel" plainText defaultValue="Donate Now" />
          </Button>
        </div>
      </div>
    </TextImageThemeTile>
  )
})
